import * as Yup from 'yup';
import { REQUIRED_FIELD } from '../../../constants';

export const DocumentValidationSchema = Yup.object().shape({
  title: Yup.string().required(REQUIRED_FIELD),
  type: Yup.string().required(REQUIRED_FIELD),
  url: Yup.string().required(REQUIRED_FIELD),
});
